export default __webpack_public_path__ + "static/media/SCDream-Extralight.f44c037d.otf";